import React from 'react';
import { FinalFormInput } from '@utex/ui-kit';
import { Balance } from '../../components/Balance';
import { useBalance } from '../../hooks/useBalance';
import { FinalFormFieldProps } from '@utex/ui-kit/dist/common/Form/types';

interface Props extends Omit<FinalFormFieldProps, 'name'> {
  name?: string;
  currency: string;
}

const currencyToSymbol: Record<string, string> = {
  USD: '$',
  RUB: '₽',
  UTT: 'UTT',
};

export const AmountInput: React.FC<Props> = ({ name, currency, ...props }) => {
  const { balance } = useBalance(currency);

  return (
    <FinalFormInput
      name={name || 'amount'}
      id={name || 'amount'}
      type="number"
      inputMode="decimal"
      allowedSymbols={/\d|\.|\,|^Backspace|^Delete|^Arrow/g}
      label={currencyToSymbol[currency] || '$'}
      isLabelShort
      placeholder="0"
      view="big"
      hintPosition="right"
      caption={<Balance balance={balance} />}
      {...props}
    />
  );
};
